import './Themes.scss'

import {ThemeIcon, ThemeIconType} from './ThemeIcon'

import {PageData} from '../../../types'
import React from 'react'
import {Theme} from '../../Theme'
import {style} from 'util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('themes', ['theme'])

export type ThemePageType = PageData & {
	icon: ThemeIconType
}

type ThemesType = {
	themes: Array<ThemeType>
	onThemeSelect: (theme: string) => void
	onAllThemesSelect: (allThemes: Array<string>) => void
	onThemeClear: () => void
	highlightedThemes: Array<string>
}

export const Themes: React.FC<ThemesType> = ({
	themes,
	onThemeSelect,
	onAllThemesSelect,
	onThemeClear,
	highlightedThemes = []
}) => {
	if (!themes || themes.length === 0) return null

	const hasHighlightedThemes = highlightedThemes?.length > 0
	const t = useTranslation('impact').projects.worldmap

	return (
		<div className={styles}>
			<div className={styles('overview')}>
				{themes.map((theme) => (
					<ThemesTheme
						key={theme.path}
						onClickHandler={() => onThemeSelect(theme.path)}
						highlighted={highlightedThemes.includes(theme.path)}
						{...theme}
					/>
				))}
				<div className={styles('overview-functionality')}>
					{!hasHighlightedThemes && (
						<Theme.Link
							onClick={() =>
								onAllThemesSelect(themes.map((theme) => theme.path))
							}
						>
							{t.select_all}
						</Theme.Link>
					)}
					{hasHighlightedThemes && (
						<Theme.Link onClick={() => onThemeClear()}>
							{t.clear_all}
						</Theme.Link>
					)}
				</div>
			</div>
		</div>
	)
}

export type ThemeType = {
	icon: ThemeIconType
	title: string
	path: string
	highlighted?: boolean
	onClickHandler?: () => void
}
export const ThemesTheme: React.FC<ThemeType> = ({
	icon,
	highlighted,
	title,
	onClickHandler
}) => {
	return (
		<div className={styles.theme.is({highlighted})}>
			<div className={styles.theme('icon')} onClick={onClickHandler}>
				<ThemeIcon icon={icon} highlighted={highlighted} />
			</div>
			<div onClick={onClickHandler} className={styles.theme('name')}>
				{title}
			</div>
		</div>
	)
}
